import React from 'react';

import './index.pc.scss';

import { ADD_CONF_OD_TITLE_TEXT } from 'utils/constant';

import PcBasicTemplate from 'components/templates/PcBasicTemplate';
import PcConfTitle from 'components/molecules/PcConfTitle';
import PcModal from 'components/molecules/PcModal';
import PcModalConfirm from 'components/molecules/PcModalConfirm';
import PcErrorArea from 'components/molecules/PcErrorArea';
import PcInputItem from 'components/molecules/PcInputItem';
import TextAreaInput from 'components/atoms/Input/TextAreaInput';
import PcFreeInputArea from 'components/molecules/PcFreeInputArea';

const PresentPC = ({
  // onChange
  onChangeOtherComment,

  // 画面項目
  confTitleList,
  otherComment,
  // モーダル
  modalList,
  confirmModal,

  // onClick
  onClickMainButton,

  // 入力チェック
  valid,
  errorDispMap,
  isApiError,
  showLoading,

  // カレンダー表示用選択済日付
  selectedDate,

}) => (
  <div className="AddConf PC">
    <PcBasicTemplate 
      path={window.location.pathname}
      onClickMainButton={onClickMainButton}
      valid={valid}
      isApiError={isApiError}
      showLoading={showLoading}
    >

      {confTitleList.map((confOD)=>{
        return(
          <PcConfTitle
            text={confOD.text}
            list={confOD.list}
            key={confOD.text}
            icon={confOD.icon}
            comment={''}
          />
        );
      })}

      {modalList.map((list)=>{
        return(
          <PcModal
            modalIsOpen={list.modalIsOpen}
            content={list.content}
            button={list.button}
            errorDispMessages={list.errorDispMessages}
            onClickCloseButton={list.onClickCloseButton}
            selectedDate={selectedDate}
            comment={!list.content.comment?(<></>):(
              <>
                <PcFreeInputArea
                  visible={list.content.comment.visible}
                  title={list.content.comment.title}
                  label={list.content.comment.label}
                  questionMark={list.content.comment.questionMark}
                  popUpTitle={list.content.comment.popUpTitle}
                  popUpDetail={list.content.comment.popUpDetail}
                  relativePosArrow={list.content.comment.relativePosArrow}
                  name={list.content.comment.name}
                  textAreaValue={list.content.comment.textAreaValue}
                  cmntOnChange={list.content.comment.cmntOnChange}
                  onInput={list.content.comment.onInput}
                  onCompositionEnd={list.content.comment.onCompositionEnd}
                  maxLength={list.content.comment.maxLength}
                  placeholder={list.content.comment.placeholder}
                  rows={list.content.comment.rows}
                  cols={list.content.comment.cols}
                  wordCount={list.content.comment.wordCount}
                  errMessage={list.content.comment.errMessage}
                />
              </>
            )}
            radioChild={list.content.radioChild}
          />
        );
      })}

      <div className="otherContactInfo">
        <PcInputItem
          title={ADD_CONF_OD_TITLE_TEXT.otherComment}
          label='任意'
          questionMark={false}
        >
          <span>
            <TextAreaInput 
              name='otherComment' 
              value={otherComment} 
              onChange={onChangeOtherComment} 
              maxLength='500' 
              suggestText={false}
            />
            <div className='word-count'>(500文字以下)</div>
            <PcErrorArea position='relative' message={errorDispMap.otherComment} />
          </span>
        </PcInputItem>
      </div>
      <PcModalConfirm
        modalIsOpen={confirmModal.modalIsOpen}
        nextButton={confirmModal.nextButton}
        cancelButton={confirmModal.cancelButton}
        onClickCloseButton={confirmModal.onClickCloseButton}
      />
    </PcBasicTemplate>
  </div>
);
  

export default PresentPC;